<section class="grupo-shell">
  <header class="grupo-hero">
    <div>
      <h2 class="grupo-title">{{ isEditMode ? 'Editar Grupo de Despesas' : 'Novo Grupo de Despesas' }}</h2>
      <p class="grupo-subtitle">Cadastre grupos para classificar suas despesas.</p>
    </div>
    <span class="grupo-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form (ngSubmit)="save()" id="grupoForm" class="grupo-card">
    <div class="form-section">
      <h3>Identificação</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="nome" class="form-label">Nome do Grupo</label>
          <input type="text" class="form-control" id="nome" [(ngModel)]="grupo.nome" name="nome" required>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button type="submit" form="grupoForm" class="btn btn-primary">Salvar</button>
  </footer>
</section>
